import e from "../components/ui/config-provider/ConfigProvider.js";
import "../components/ui/config-provider/index.js";
import { onKeyDown as t } from "../node_modules/.pnpm/@vueuse_core@13.3.0_vue@3.5.16_typescript@6.0.2_/node_modules/@vueuse/core/index.js";
import n from "../components/ui/tooltip/wrapper/TooltipWrapper.js";
import "../components/ui/tooltip/index.js";
import { createApp as r, createVNode as i, ref as a } from "vue";
//#region src/directives/tooltip.tsx
var o = /* @__PURE__ */ new WeakMap();
function s(e) {
	if (e.modifiers.top) return "top";
	if (e.modifiers.bottom) return "bottom";
	if (e.modifiers.left) return "left";
	if (e.modifiers.right) return "right";
}
function c(e) {
	return e.value === void 0 || e.value === null || e.value === "";
}
function l(e, n, r) {
	function i() {
		r.value = !0;
	}
	function a() {
		r.value = !1;
	}
	let o = e.querySelector("[data-slot=\"tooltip-trigger\"]"), s = null;
	return o && (o.addEventListener("pointerenter", i), o.addEventListener("pointerleave", a), n.addEventListener("focus", i), n.addEventListener("blur", a), s = t("Escape", a)), function() {
		let t = e.querySelector("[data-slot=\"tooltip-trigger\"]");
		t && (t.removeEventListener("pointerenter", i), t.removeEventListener("pointerleave", a), n.removeEventListener("focus", i), n.removeEventListener("blur", a), s?.());
	};
}
function u({ el: t, binding: a, placement: o, vnode: s, open: c }) {
	return r({ render() {
		return i(e, { directivesProvides: s?.ctx?.provides ? { ...s.ctx.provides } : void 0 }, { default: () => [i(n, {
			content: a.value,
			placement: o,
			reference: t,
			open: c.value,
			usedInDirectives: !0
		}, { default: () => [i("div", {
			"data-tooltip-children": !0,
			style: "display: contents;"
		}, null)] })] });
	} });
}
function d(e, t, n) {
	e.dataset.tooltipProcessed = "true";
	let r = document.createElement("div");
	r.style.display = "contents", e.parentElement && e.parentElement.insertBefore(r, e);
	let i = s(t), c = a(!1), d = u({
		el: e,
		binding: t,
		placement: i,
		vnode: n,
		open: c
	});
	d.mount(r), r.querySelector("[data-tooltip-children]")?.appendChild?.(e), o.set(e, {
		container: r,
		content: t.value,
		placement: i,
		app: d,
		open: c,
		cleanup: l(r, e, c)
	});
}
function f(e, t, n, r) {
	let i = s(n);
	if (!(e.content !== n.value || e.placement !== i)) return;
	e.cleanup(), t.remove(), e.app.unmount(), e.container.innerHTML = "";
	let a = u({
		el: t,
		binding: n,
		placement: i,
		vnode: r,
		open: e.open
	});
	a.mount(e.container), e.container.querySelector("[data-tooltip-children]")?.appendChild?.(t), e.app = a, e.content = n.value, e.placement = i, e.cleanup = l(e.container, t, e.open);
}
var p = {
	mounted(e, t, n) {
		c(t) || e.dataset.tooltipProcessed || d(e, t, n);
	},
	updated(e, t, n) {
		let r = o.get(e);
		if (!r) return d(e, t, n);
		f(r, e, t, n);
	},
	unmounted(e) {
		let t = o.get(e);
		t && (t.cleanup(), t.app.unmount(), t.container.remove()), o.delete(e);
	}
};
//#endregion
export { p as default };

//# sourceMappingURL=tooltip.js.map